module.exports = __webpack_public_path__ + "img/prize1.7a54cead.png";